import { ulid } from "ulid";

export const genId = (seedTime?: number) => ulid(seedTime)
export const genVr = (seedTime?: number) => ulid(seedTime)

export const flattenMap = (map) => {
    let flatObject = {};
  
    for (let [key, value] of map) {
      if (value instanceof Map) {
        value = flattenMap(value);
      }
      flatObject[key] = value;
    }
  
    return flatObject;
  }
type ResultType<C, T = string> = {
  [Property in keyof T]: C;
};

export const extractAndExport = async <T, C = any>(data: C[], 
  handlers: ResultType<(value: C) => C | null, T>): Promise<ResultType<C[], T>> => {
  const result: ResultType<C[], T> = {} as ResultType<C[], T>;

  for (const item of data) {
    for (const label in handlers) {
      if (!result[label]) {
        result[label] = [] as C[];
      }
      const normalized = handlers[label].call(this, item);
      if (normalized) result[label].push(normalized); 
    }
  }

  return result;
};